/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Last_Used_ColInputs */

const en_settings_apikeys_last_used_col = /** @type {(inputs: Settings_Apikeys_Last_Used_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Used`)
};

/**
* | output |
* | --- |
* | "Last Used" |
*
* @param {Settings_Apikeys_Last_Used_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_last_used_col = /** @type {((inputs?: Settings_Apikeys_Last_Used_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Last_Used_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_last_used_col(inputs)
});
export { settings_apikeys_last_used_col as "settings.apikeys.last_used_col" }